import { render, staticRenderFns } from "./ManutencaoModal.vue?vue&type=template&id=12f57ece&scoped=true&"
import script from "./ManutencaoModal.vue?vue&type=script&lang=js&"
export * from "./ManutencaoModal.vue?vue&type=script&lang=js&"
import style0 from "./ManutencaoModal.vue?vue&type=style&index=0&id=12f57ece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f57ece",
  null
  
)

export default component.exports